var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5942_765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 20.777C9.1296 20.5796 8.29367 20.2529 7.51999 19.808",
    stroke: "#25B93F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.22302C15.9882 3.67709 17.7632 4.79271 19.0347 6.38723C20.3061 7.98174 20.9984 9.96067 20.9984 12C20.9984 14.0394 20.3061 16.0183 19.0347 17.6128C17.7632 19.2073 15.9882 20.323 14 20.777",
    stroke: "#25B93F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57899 17.093C4.03349 16.3004 3.61919 15.4252 3.35199 14.501",
    stroke: "#25B93F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12399 10.5C3.28399 9.55002 3.59199 8.65002 4.02399 7.82502L4.19299 7.52002",
    stroke: "#25B93F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90701 4.57902C7.84267 3.93492 8.89233 3.47474 10 3.22302",
    stroke: "#25B93F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11 14L15 10",
    stroke: "#25B93F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5942_765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCheckIcon);
export default __webpack_public_path__ + "static/media/progress-check-icon.2e3e1483cc15176e4c14756de6be97e2.svg";
export { ForwardRef as ReactComponent };